import { api } from "../../services/axios";

export const useStudioEad = () => {
  const handleRedirectToMedsystemsAcademy = async ({ email, customerName, course }) => {
    try {
      const { data } = await api.post("/portalCliente/studio_ead_medacademy", {
        email,
        customerName,
        course,
      });

      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const handleRedirectToBeautyAcademy = async ({ email, customerName, course }) => {
    try {
      const { data } = await api.post("/portalCliente/studio_ead_beautyacademy", {
        email,
        customerName,
        course,
      });

      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetUserInfo = async ({ jsonid, cnpj }) => {
    try {
      const { data } = await api.post("/portalCliente/consulta/dados_cad", {
        jsonid,
        cnpj,
      });

      const userData = data?.data?.[0];

      return {
        email: userData?.[0]?.trim?.() || userData?.[10]?.trim?.(),
      };
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetCourses = async ({ cnpj }) => {
    try {
      const { data } = await api.get("/portalCliente/courses", {
        params: {
          cpfCnpj: cnpj,
        },
      });

      return data;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleRedirectToMedsystemsAcademy,
    handleRedirectToBeautyAcademy,
    handleGetUserInfo,
    handleGetCourses,
  };
};
